module.exports = __webpack_public_path__ + "img/b2.46dc240e.png";